
export const isDateInRange = (date_start, date_end) => {
    if (!date_start || !date_end) {
        return false
    }

    try {
        const [startDay, startMonth, startYear] = date_start.split('/').map(Number);
        const startDate = new Date(startYear, startMonth - 1, startDay);

        const [endDay, endMonth, endYear] = date_end.split('/').map(Number);
        const endDate = new Date(endYear, endMonth - 1, endDay);

        const today = new Date();
        const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

        const normalizedStart = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const normalizedEnd = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

        return currentDate >= normalizedStart && currentDate <= normalizedEnd;
    } catch (error) {
        console.error('Error parsing dates:', error);
        return false;
    }
};